import { Ability, AbilityBuilder, type AbilityClass } from '@casl/ability'
import type UserDomain from '../types/domain/user-domain'

type UserType = Pick<UserDomain, 'type'>['type']

export type Action = 'manage' | 'create' | 'read' | 'update' | 'delete'
export type Subject = 'all' | 'Admin' | 'Researcher' | 'DashboardScreen'

export type AppAbility = Ability<[Action, Subject]>

export function defineRulesByUserType (userType?: UserType) {
  const { can, cannot, rules } = new AbilityBuilder(
    Ability as AbilityClass<AppAbility>
  )

  if (userType === 'admin') {
    can('manage', 'all')
  } else if (userType === 'researcher') {
    can('manage', 'all')
    cannot(['create', 'update', 'delete', 'read'], 'Admin')
    cannot(['create', 'update', 'delete'], 'Researcher')
    cannot('read', 'DashboardScreen')
  }

  return rules
}

export default function buildAbilityFor (userType?: UserType) {
  return new Ability<[Action, Subject]>(defineRulesByUserType(userType))
}
